<template>
  <section>
    <section class="ew-smaller-container">

        <div class="opps">
            <div class="ew-opps-reminder">
                <div class="row d-print-none">
                    <div class="col-9">
                        <p >Ficha digital. No es necesario imprimir.</p>
                    </div>
                    <div class="col-3">
                        <button @click="printDocument" class="ew-btn-primary p-1"><img  src="@/assets/images/printer.svg"  alt=""></button>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col">
                    <div class="opps-brand"><img src="@/assets/images/oxxopay_brand.png" alt="OXXOPay"></div>
                </div>
                <div class="col">
                    <div class="ew-opps-ammount ">
                        <h3 class="ew-card-shiment-title" >Monto a pagar</h3>
                        <h2>$ {{getTotalPrice(shipments)}} <sup>MXN</sup></h2>
                        <p>OXXO cobrará una comisión adicional al momento de realizar el pago.</p>
                    </div>
                    
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="ew-opps-reference">
                        <h3 class="ew-card-shiment-title" >Referencia</h3>
                        <h1 >{{reference}}</h1>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="ew-opps-instructions">
                        <h3 class="ew-card-shiment-title" >Instrucciones</h3>
                        <ol class="text-justify">
                            <li>Acude a la tienda OXXO más cercana. <a href="https://www.google.com.mx/maps/search/oxxo/" target="_blank">Encuéntrala aquí</a>.</li>
                            <li>Indica en caja que quieres realizar un pago de <strong>OXXOPay</strong>.</li>
                            <li>Dicta al cajero el número de referencia en esta ficha para que tecleé directamete en la pantalla de venta.</li>
                            <li>Realiza el pago correspondiente con dinero en efectivo.</li>
                            <li>Al confirmar tu pago, el cajero te entregará un comprobante impreso. <strong>En el podrás verificar que se haya realizado correctamente.</strong> Conserva este comprobante de pago.</li>
                        </ol>
                        <div class="ew-opps-footnote">Al continuar estos pasos, te enviarémos un correo con un boton para descargar la etiqueta de tu envío (guía) de manera inmediata.</div>
                    </div>
                </div>
            </div>
            <div class="row" v-for="(shipment, i) in shipments" v-bind:key="i">
                <div class="col">
                    <div >
                        <span class="ew-spand-card">Transportista</span>
                        <img class="ew-size-imge-services" :src="shipment.selected_service.carrier_logo_url_svg" alt="">
                    </div>
                    <div>
                        <span class="ew-spand-card">Servicio</span>
                        <p>{{shipment.selected_service.carrier_service_name}}</p>
                    </div>
                </div>
                <br>
                <div class="col">
                    <div>
                        <span class="ew-spand-card">Destino:</span>
                        <p>{{shipment.destination_direction.full_name}}<br> 
                        {{shipment.destination_direction.address}}<br>
                        {{shipment.destination_direction.postal_code}} {{shipment.destination_direction.city}}
                        <br>
                        Mexico</p>
                    </div>
                    <div>
                        <span class="ew-spand-card">Precio:</span>
                        <p>{{getUnitPrice(shipment.selected_service.total_amount)}}</p>
                    </div>
                </div>
            </div>	
        </div>
    </section>
    
   
  </section>
</template>

<script>
import axios from 'axios'
import commons from '../commons'
import { mapGetters, mapActions, mapMutations } from 'vuex'


export default {
  name: 'CashBarcode',
  data () {
    return {
        referencesPay:'',
        shipments:null,
        reference:""
    }
  },
  watch: {},
  methods: {
      getShipmetsByReferences(_id){
        const url = `${commons.apiURL}/api/v1/shipments/references/${_id}`
        axios.get(url).then(response => {
            this.shipments = response.data
            this.reference = this.shipments[0].reference
        }).catch(() => {

        })
      },
    getTotalPrice() {
        let total = 0;
        if (this.shipments !== null) {
            this.shipments.forEach(shipment => {
                total =  total + parseFloat(parseFloat(shipment.selected_service.total_amount).toFixed(2));    
            });
            return total;    
        } 
    },
    getUnitPrice(total_amount) {
        let mount = parseFloat(parseFloat(total_amount).toFixed(2));
        return mount;
    },
    printDocument(){
        window.print()
    }
  },
  computed: {},
  created () {
      this.referencesPay = this.$route.query['references']
      this.getShipmetsByReferences(this.referencesPay)
  },
  components: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../assets/styles/variables";
@import "../assets/styles/ew-components";
.ew-btn-primary { @include ew-btn-primary; }
.ew-spand-card{
    font-size: 12px;
    color: #999;
}



.opps {
	max-width: 550px; 
	border-radius: 4px;
	box-sizing: border-box;
	padding-left: 5%;
    padding-right: 5%;
	margin: auto;
	overflow: hidden;
	border: 1px solid #b0afb5;
	font-family: 'Open Sans', sans-serif;
	color: #4f5365;
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.ew-opps-reminder {
	position: relative;
	top: -1px;
	padding: 9px 0 10px;
	font-size: 11px;
	text-transform: uppercase;
	text-align: center;
	color: #ffffff;
	background: #000000;
    margin: auto;
    img{
        width: 32px;
        cursor: pointer;

    }
}


.opps-brand {
	max-width: 45%;
}

.opps-brand img {
	max-width: 150px;
	margin-top: 2px;
}


.ew-opps-ammount {
	max-width: 100%;
    h2 {
        font-size: 36px;
        color: #000000;
        line-height: 24px;
        margin-bottom: 15px;
    }

    h2 sup {
        font-size: 16px;
        position: relative;
        top: -2px
    }

    p {
        font-size: 10px;
        line-height: 14px;
    }
}

.ew-card-shiment-title{
    margin-bottom: 10px;
	font-size: 15px;
	font-weight: 600;
	text-transform: uppercase;
}

.ew-opps-footnote {
	margin-top: 22px;
	padding: 22px 20 24px;
	color: #108f30;
	text-align: center;
	border: 1px solid #108f30;
	border-radius: 4px;
	background: #ffffff;
}

.ew-opps-reference{
    h1{
    font-size: 45px;
	color: #000000;
	text-align: center;
	margin-top: -1px;
	padding: 6px 0 7px;
	border: 1px solid #b0afb5;
	border-radius: 4px;
	background: #f8f9fa
    }
}

.ew-opps-instructions{
    margin: 32px -45px 0;
	padding: 32px 45px 45px;
	border-top: 1px solid #b0afb5;
	background: #f8f9fa;
    ol {
        margin: 17px 0 0 16px;
    }

    li + li {
        margin-top: 10px;
        color: #000000;
    }

    a {
        color: #1155cc;
    }

}
    
.ew-size-imge-services{
    width: 200px
}

</style>



// WEBPACK FOOTER //
// src/components/CashBarcode.vue